<template>
  <div class="centered-logo-nav" id="header">
    <div class="header-top hidden-xs hidden-sm">
      <nav class="navbar nav-right navigation_with_contact" style="">
        <div class="container">
          <ul
            class="nav navbar-nav navbar-left"
            data-more-dropdown=""
            role="menubar"
          >
            <li role="none">
              <a href="#" role="menuitem" target="">Home</a>
            </li>
            <li role="none">
              <a href="#" role="menuitem" target="">Contact Us</a>
            </li>
            <li
              class="dropdown"
              @mouseenter="addOpen"
              @mouseleave="removeOpen"
              role="none"
            >
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="New Vehicles"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >New Vehicles</a
              >
              <ul aria-label="New Vehicles" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#" role="menuitem" target="">Browse Inventory</a>
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Schedule Test Drive</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target="">Quick Quote</a>
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Trade In Evaluation</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target="">Shop Our Ads</a>
                </li>
              </ul>
            </li>
            <li
              class="dropdown"
              @mouseenter="addOpen"
              @mouseleave="removeOpen"
              role="none"
            >
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="Pre-Owned Vehicles"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >Pre-Owned Vehicles</a
              >
              <ul
                aria-label="Pre-Owned Vehicles"
                class="dropdown-menu"
                role="menu"
              >
                <li role="none">
                  <a href="#" role="menuitem" target="">Browse Inventory</a>
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Vehicles Under $12,000</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Locate Your Vehicle</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Trade In Evaluation</a
                  >
                </li>
              </ul>
            </li>
            <li id="logo-item">
              <a class="centered-logo" href="#"
                ><img
                  alt=""
                  class="dealer-logo"
                  :src="[!logoURL ? images.logoExample[0] : logoURL]"
                  title=""
              /></a>
            </li>
            <li
              class="dropdown"
              @mouseenter="addOpen"
              @mouseleave="removeOpen"
              role="none"
            >
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="Specials"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >Specials</a
              >
              <ul aria-label="Specials" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >New Vehicle Specials</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target="">Pre-Owned Specials</a>
                </li>
              </ul>
            </li>
            <li
              class="dropdown"
              @mouseenter="addOpen"
              @mouseleave="removeOpen"
              role="none"
            >
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="Financing"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >Financing</a
              >
              <ul aria-label="Financing" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Finance Information</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Finance Application</a
                  >
                </li>
              </ul>
            </li>
            <li
              class="dropdown"
              @mouseenter="addOpen"
              @mouseleave="removeOpen"
              role="none"
            >
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="Service &amp; Parts"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >Service &amp; Parts</a
              >
              <ul
                aria-label="Service &amp; Parts"
                class="dropdown-menu"
                role="menu"
              >
                <li role="none">
                  <a href="#" role="menuitem" target="">Service Info</a>
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Service Appointments</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target="">Service Coupons</a>
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target="">Parts Request</a>
                </li>
              </ul>
            </li>
            <li
              class="dropdown"
              @mouseenter="addOpen"
              @mouseleave="removeOpen"
              role="none"
            >
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="About"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >About</a
              >
              <ul aria-label="About" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#" role="menuitem" target="">Reviews</a>
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Career Opportunities</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target="">Staff Directory</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      <div class="header-bottom hidden-xs hidden-sm">
        <header data-collapsible="" id="desktop-header">
          <div class="sub-navigation-vehicle-search">
            <div class="container">
              <div class="col-search-bar">
                <div class="search-bar">
                  <form action="/vehicles" role="search">
                    <div class="input-group">
                      <input
                        aria-label="Search Bar"
                        autocomplete="off"
                        autocorrect="off"
                        class="form-control input-search"
                        data-custom="false"
                        data-placement="bottom"
                        data-search-suggestions="true"
                        data-suggest="true"
                        data-top="Search this site..."
                        name="query"
                        placeholder="Search this site..."
                        spellcheck="false"
                        title="Search this site..."
                        type="text"
                        value=""
                      />
                      <span class="input-group-btn">
                        <button
                          aria-label="search text"
                          class="btn btn-default no-border-left"
                          type="submit"
                        >
                          <i aria-hidden="true" class="fa fa-search"></i>
                        </button>
                      </span>
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-vehicle-browse">
                <div class="vehicle-browse-ajax">
                  <form class="search-form vehicle-search-form" method="get">
                    <div class="search-form-option">
                      <div class="form-group no-margin-bottom">
                        <label
                          class="visuallyhidden"
                          for="header-vehicle-type"
                          >Select vehicle type:</label
                        ><select
                          class="form-control vehicle-search search-inv-type"
                          id="header-vehicle-type"
                          name="type"
                          ><option data="true" value="new">New</option
                          ><option data="false" value="used"
                            >Used</option
                          ></select
                        >
                      </div>
                    </div>
                    <div class="search-form-option">
                      <div class="form-group no-margin-bottom">
                        <label
                          class="visuallyhidden"
                          for="header-vehicle-make"
                          >Select vehicle make:</label
                        ><select
                          class="form-control vehicle-search vehicle-search-make"
                          id="header-vehicle-make"
                          name="make"
                          ><option value="Make">{{ brandName }}</option></select
                        >
                      </div>
                    </div>
                    <div class="search-form-option">
                      <div class="form-group no-margin-bottom">
                        <label
                          class="visuallyhidden"
                          for="header-vehicle-model"
                          >Select vehicle model:</label>
                        <select
                          class="form-control vehicle-search vehicle-search-model"
                          id="header-vehicle-model"
                          name="model">
                          <option value="default">Model</option>
                        </select>
                      </div>
                    </div>
                    <div class="search-form-btn">
                      <div class="form-group no-margin-bottom">
                        <input
                          aria-label="Click here to submit"
                          class="vehicle-search-submit btn form-control"
                          value="Search"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
    <div class="visible-sm visible-xs">
      <div class="mobile-contact-bar">
        <div class="toggle-side-menu">
          <a class="mobile-menu-toggle" @click="toggleSideNav">
            <span class="icon-label">MENU</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </a>
        </div>
        <div class="mobile-dealer-logo pull-left">
          <a href="#">
            <img alt="Logo" class="dealer-logo" :src="[!logoURL ? images.logoExample[0] : logoURL]" title="Logo">
          </a>
        </div>
        <div class="contact-info">
          <div class="contact-item mobile-sales-phone" id="toggle-click-to-call">
            <i class="fa fa-phone"></i>
            <a class="hidden-xs" href="#"></a>
          </div>
          <a class="contact-item mobile-get-directions"
            data-action="Address Click" data-category="Hours &amp; Directions" data-label="Dealership Address Link"
            href="#" itemprop="hasMap">
            <i aria-hidden="true" class="fa fa-map-marker"></i>
            <span class="hidden-xs">Directions</span>
          </a>
        </div>
      </div>
      <div class="mobile-nav-bar sidr left" id="sidr" role="navigation" style="transition: left 0.2s ease 0s;" v-if="sideNavOpen">
        <div class="navbar-inner nav navbar-nav">
          <ul class="side-nav" role="menu">
            <div class="search-bar">
              <form action="/vehicles" role="search">
                <div class="input-group">
                  <input aria-label="Search Bar" autocomplete="off" autocorrect="off" class="form-control input-search" data-custom="false" data-placement="bottom" data-search-suggestions="true" data-suggest="true" data-top="" name="query" placeholder="Search this site..." spellcheck="false" title="Search this site..." type="text" value="">
                  <span class="input-group-btn">
                    <button aria-label="search text" class="btn btn-default no-border-left" type="submit">
                      <i aria-hidden="true" class="fa fa-search"></i>
                    </button>
                  </span>
                </div>
              </form>
            </div>
            <li role="none">
              <a href="#" role="menuitem" target="">Home</a>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#new-vehicles" aria-expanded="false" aria-controls="new-vehicles">New Vehicles</a>
              <ul id="new-vehicles" aria-label="New Vehicles" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Schedule Test Drive</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Quick Quote</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Shop Our Ads</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#pre-owned-vehicles" aria-expanded="false" aria-controls="pre-owned-vehicles">Pre-Owned Vehicles</a>
              <ul id="pre-owned-vehicles" aria-label="Pre-Owned Vehicles" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Vehicles Under $12,000</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Locate Your Vehicle</a>
                </li>
                <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#specials" aria-expanded="false" aria-controls="specials">Specials</a>
              <ul id="specials" aria-label="Specials" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">New Vehicle Specials</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Pre-Owned Specials</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#financing" aria-expanded="false" aria-controls="financing">Financing</a>
              <ul id="financing" aria-label="Financing" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Finance Information</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Finance Application</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#service" aria-expanded="false" aria-controls="service">Service &amp; Parts</a>
              <ul id="service" aria-label="Service &amp; Parts" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Service Info</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Service Appointments</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Service Coupons</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Parts Request</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#about" aria-expanded="false" aria-controls="about">About</a>
              <ul id="about" aria-label="About" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Reviews</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Career Opportunities</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Staff Directory</a></li>
              </ul>
            </li>
            <div class="close-mobile-wrap" @click="closeSideNav">
              <span class="close-mobile-nav">
                <i class="fa fa-close">&nbsp;</i>
                <span>close</span>
              </span>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images', 'logoURL'],
  data() {
    return {
      sideNavOpen: false,
      brand: this.$store.state.chosenBrand
    };
  },
  mounted() {},
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  methods: {
    addOpen: function(e) {
      e.target.classList.add("open");
    },
    removeOpen: function(e) {
      e.target.classList.remove("open");
    },
    toggleSideNav: function() {
      this.sideNavOpen = !this.sideNavOpen;
    },
    closeSideNav: function() {
      this.sideNavOpen = false;
    },
  },
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.centered-logo-nav .dealer-logo {
  max-width: 280px;
  max-height: 70px;
}
#header.centered-logo-nav .navigation_with_contact .fixed-right {
  right: 10px;
}
#header.centered-logo-nav .navigation_with_contact .nav-contact-desktop {
  font-size: 13px;
}
#header.centered-logo-nav .navigation_with_contact .nav-contact-desktop a,
#header.centered-logo-nav .navigation_with_contact .nav-contact-desktop a:hover {
  color: white;
}
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li {
  min-height: 50px;
  display: inline-block;
  float: none;
  vertical-align: middle;
}
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li > a {
  font-size: 13px;
  opacity: 0.7;
  color: var(--primary-dark);
  transition: all .3s ease;
}
#header.centered-logo-nav .navigation_with_contact .navbar-nav > #logo-item > a {
  opacity: 0.9;
}
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li > a:hover, #header.centered-logo-nav .navigation_with_contact .navbar-nav > li.open > a {
  background: transparent;
}
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li > a:hover,
#header.centered-logo-nav .navigation_with_contact .navbar-nav > #logo-item > a:hover,
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li.open > a,
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li#more-dropdown:hover > a {
  opacity: 1;
}
.visuallyhidden {
  display: none;
}
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li .centered-logo, #header.centered-logo-nav .navigation_with_contact .navbar-nav > li#logo-item + li > a {
  border-left-width: 0 !important;
}
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li .dropdown-menu {
  margin-top: -0.5px;
  padding: 0;
}
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li .dropdown-menu > li {
  height: 40px;
  line-height: 40px;
  margin: 0;
}
#header.centered-logo-nav .navigation_with_contact .navbar-nav > li .dropdown-menu > li > a {
  height: 40px;
  line-height: 40px;
  padding: 0 5px;
  margin: 0;
}
#header.centered-logo-nav .sub-navigation-vehicle-search {
  background: #fff;
  font-size: 12px;
  color: var(--primary-dark);
  width: 100%;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .col-search-bar {
  display: inline-block;
  width: calc(100% - 380px);
}
#header.centered-logo-nav .sub-navigation-vehicle-search .col-vehicle-browse {
  width: 380px;
  display: inline-block;
  vertical-align: top;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-option {
  height: 50px;
  max-width: 95px;
  line-height: 50px;
  display: inline-block;
  width: 100%;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-option select, #header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-option option, #header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-option .form-group {
  font-weight: 500 !important;
  font-size: 15px;
  padding-right: 0px;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-option .vehicle-search {
  background: var(--primary-color);
  color: white;
  height: 48px;
  border-radius: 5px;
  border-color: #fff;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-option .vehicle-search:hover {
  opacity: .7;
  cursor: pointer;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-btn {
  display: inline-block;
  vertical-align: top;
  width: 95px;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-btn .btn {
  font-size: 16px;
  border-radius: 5px;
  border-color: #fff;
  padding: 0px 12px;
  height: 48px;
  width: 100%;
  color: white;
  font-weight: 500;
  background: var(--secondary-dark);
  display: block;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-btn .btn:hover {
  opacity: .7;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-bar {
  padding: 0;
  display: inline-block;
  width: 95%;
  position: relative;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-bar .input-group input, #header.centered-logo-nav .sub-navigation-vehicle-search .search-bar .input-group .input-group-btn .btn {
  background: #d7d7d7;
  height: 50px;
  width: 100%;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-bar .input-group input {
  color: #000;
  font-size: 16px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-bar .input-group .input-group-btn .btn {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
#header.centered-logo-nav .sub-navigation-vehicle-search .search-bar .search-form {
  float: none;
  display: inline-block;
  margin-bottom: 10px;
  margin-left: 0;
}
.search-bar .input-search {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .search-bar button {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
.nav-right {
  margin-bottom: 0px !important;
}
#header.centered-logo-nav #desktop-header[data-collapsible="true"]
  .sub-navigation-vehicle-search {
  position: static !important;
}
.mobile-contact-bar {
  height: 70px;
  background: #fff;
  width: 100%;
}
.mobile-contact-bar .mobile-dealer-logo img {
  padding: 10px;
}
.mobile-contact-bar .mobile-menu-toggle {
  width: 60px;
  height: 70px;
  padding: 25px 15px;
  float: left;
  background: transparent;
}
.mobile-contact-bar .mobile-menu-toggle .icon-bar {
  display: block;
  margin-top: 4px;
  width: 30px;
  height: 3px;
  border-radius: 1px;
  background-color: var(--primary-color);
}
.mobile-contact-bar .mobile-menu-toggle .icon-label {
  display: none;
}
.mobile-contact-bar .contact-info {
  float: right;
  margin-top: 1.6em;
  margin-right: 1.2em;
}
.mobile-contact-bar .contact-info .contact-item {
  display: inline-block;
  vertical-align: middle;
  color: var(--primary-color);
  font-size: 1.7em;
  letter-spacing: 0.05em;
  margin-right: 0.7em;
}
.mobile-contact-bar .contact-info .contact-item:hover {
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
}
.mobile-contact-bar .contact-info .contact-item .fa {
  margin-right: 0.1em;
}
.mobile-contact-bar .contact-info .contact-item a {
  color: inherit;
}
.mobile-contact-bar .contact-info .contact-item a:hover {
  text-decoration: inherit;
}
.mobile-nav-bar .side-nav {
  border-bottom: none;
}
.mobile-nav-bar .search-bar {
  border: 1px solid #4d4d4d;
}
.mobile-nav-bar .search-bar form {
  margin: 0;
}
.mobile-nav-bar .search-bar .input-search {
  margin: 0;
  padding: 5;
  height: 40px;
}
.mobile-nav-bar .search-bar .input-group-btn {
  padding: 0;
}
.mobile-nav-bar .search-bar .input-group-btn button {
  height: 40px;
}
.mobile-nav-bar .side-nav > li {
  display: block;
  float: left;
  width: 100%;
  border-bottom: 1px solid #333;
}
.mobile-nav-bar .side-nav > li > a,
.mobile-nav-bar .navbar-inner > ul > li.dropdown.open > a {
  background: #222;
  color: #fff;
  display: block;
  height: 40px;
  line-height: 20px;
  padding: 10px 15px;
  color: #fff;
  white-space: nowrap;
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  text-transform: none;
  margin: 0;
}
.mobile-nav-bar .side-nav > li > a:hover,
.mobile-nav-bar .navbar-inner > ul > li.dropdown.open > a:hover {
  background: #1c1c1c;
}
.mobile-nav-bar .side-nav > li > ul.dropdown-menu {
  width: 100%;
  left: 0;
  display: none;
  position: relative;
}
.mobile-nav-bar .side-nav > li > ul.dropdown-menu > li > a {
  height: 40px;
  line-height: 40px;
  background: #444;
  font-size: 14px;
  color: #fff;
  text-align: left;
  float: left;
  min-width: 100%;
  position: relative;
  border-bottom: 1px solid #333;
}
.mobile-nav-bar .side-nav > li > ul.dropdown-menu > li > a:hover {
  background: #333;
}
.mobile-nav-bar .close-mobile-wrap {
  text-align: right;
  padding: 10px 15px;
}
.mobile-nav-bar .close-mobile-wrap .close-mobile-nav {
  color: #aaa;
}
.mobile-nav-bar .close-mobile-wrap .close-mobile-nav:hover {
  cursor: pointer;
  color: #fff;
}

@media (min-width: 1201px) {
  #header.centered-logo-nav .navigation_with_contact {
    box-shadow: none;
    background: #fff;
  }
  #header.centered-logo-nav .navigation_with_contact .navbar-left {
    float: none !important;
    text-align: center;
  }
  #header.centered-logo-nav .navigation_with_contact .navbar-left > li > a {
    color: var(--primary-dark);
  }
  #header.centered-logo-nav .navigation_with_contact .navbar-left > li:not(:first-child) > a {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: #d6d7d8;
  }
  #header.centered-logo-nav .navigation_with_contact > .container {
    width: 100%;
    padding: 15px 0;
    max-width: 1185px;
  }
}

@media (max-width: 1200px) and (min-width: 768px) {
  #header.centered-logo-nav .hidden-sm {
    display: none !important;
  }
  #header.centered-logo-nav .visible-sm {
    display: block !important;
  }
  #header.centered-logo-nav .mobile-dealer-logo .dealer-logo {
    max-height: 70px;
  }
}

@media (max-width: 767px) {
  #header.centered-logo-nav .sub-navigation-vehicle-search .search-form .search-form-option {
    max-width: 80px;
  }
  #header.centered-logo-nav .mobile-dealer-logo .dealer-logo {
    max-height: 55px;
  }
  #header.centered-logo-nav .mobile-contact-bar {
    height: 55px;
  }
  #header.centered-logo-nav .mobile-contact-bar .mobile-menu-toggle {
    height: 55px;
    padding: 15px;
    cursor: pointer;
  }
  #header.centered-logo-nav .mobile-contact-bar .contact-info {
    margin-top: 0.8em;
    margin-right: 0;
  }
  #header.centered-logo-nav .mobile-contact-bar .contact-info .contact-item {
    font-size: 2.4em;
  }
  #header.centered-logo-nav .side-nav .open .dropdown-menu > li > a {
    padding: 0 25px 0 !important;
  }
}

@media (max-width: 480px) {
  #header.centered-logo-nav .mobile-dealer-logo .dealer-logo {
    max-width: 230px;
  }
}

@media (max-width: 400px) {
  #header.centered-logo-nav .mobile-dealer-logo .dealer-logo {
    max-width: 145px;
  }
}

.mobile-contact-bar {
  height: 70px;
  background: var(--primary-light);
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  }
  .mobile-contact-bar .mobile-dealer-logo img {
  padding: 10px;
  }
  .mobile-contact-bar .mobile-menu-toggle {
  width: 60px;
  height: 70px;
  padding: 25px 15px;
  float: left;
  background: transparent;
  cursor: pointer;
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-bar {
  display: block;
  margin-top: 4px;
  width: 30px;
  height: 3px;
  border-radius: 1px;
  background-color: var(--primary-color);
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-label {
  display: none;
  }
  .mobile-contact-bar .contact-info {
  float: right;
  margin-top: 1.6em;
  margin-right: 1.2em;
  }
  .mobile-contact-bar .contact-info .contact-item {
  display: inline-block;
  vertical-align: middle;
  color: var(--primary-color);
  font-size: 1.7em;
  letter-spacing: .05em;
  margin-right: .7em;
  }
  .mobile-contact-bar .contact-info .contact-item:hover {
  text-decoration: none;
  cursor: pointer;
  }
  .mobile-contact-bar .contact-info .contact-item .fa {
  margin-right: .1em;
  }
  .mobile-contact-bar .contact-info .contact-item a {
  color: inherit;
  }
  .mobile-contact-bar .contact-info .contact-item a:hover {
  text-decoration: inherit;
  }
  .mobile-nav-bar .navbar-nav {
    margin: 0;
  }
  .mobile-nav-bar .side-nav {
  border-bottom: none;
  }
  .mobile-nav-bar .search-bar {
  border: 1px solid #4d4d4d;
  }
  .mobile-nav-bar .search-bar form {
  margin: 0;
  }
  .mobile-nav-bar .search-bar .input-search {
  margin: 0;
  height: 40px;
  }
  .mobile-nav-bar .search-bar .input-group-btn {
  padding: 0;
  }
  .mobile-nav-bar .search-bar .input-group-btn button {
  height: 40px;
  }
  .mobile-nav-bar .side-nav > li {
  display: block;
  float: left;
  width: 100%;
  border-bottom: 1px solid #333;
  }
  .mobile-nav-bar .side-nav > li > a, .mobile-nav-bar .navbar-inner > ul > li.dropdown > a {
  background: #222;
  color: #fff;
  display: block;
  height: 40px;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 15px;
  color: #fff;
  white-space: nowrap;
  font-weight: normal;
  text-align: left;
  text-transform: none;
  margin: 0;
  }
  .mobile-nav-bar .side-nav > li > a:hover, .mobile-nav-bar .navbar-inner > ul > li.dropdown > a:hover {
  background: #1c1c1c;
  }
  .mobile-nav-bar .side-nav > li > ul {
  width: 100%;
  left: 0;
  position: relative;
  list-style: none;
  }
  .mobile-nav-bar .side-nav > li > ul > li > a {
  height: 40px;
  line-height: 40px;
  background: #444;
  font-size: 14px;
  color: #fff;
  text-align: left;
  float: left;
  min-width: 100%;
  position: relative;
  border-bottom: 1px solid #333;
  padding-left: 30px;
  }
  .mobile-nav-bar .side-nav > li > ul > li > a:hover {
  background: #333;
  }
  .mobile-nav-bar .close-mobile-wrap {
  text-align: right;
  padding: 10px 15px;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav {
  color: #aaa;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav:hover {
  cursor: pointer;
  color: #fff;
  }
  .sidr {
    position: absolute;
    z-index: 20;
    top: 70px;
    height: 100%;
    min-height: 600px;
    width: 260px;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 15px;
    background: #333;
    color: #fff;
    box-shadow: 0 0 5px 5px #222 inset;
  }
  .sidr .input-search {
    width: 100%;
    font-size: 13px;
    padding: 5px;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 0 10px;
    border-radius: 2px;
    border: 0;
    background: rgba(0,0,0,0.1);
    color: rgba(255,255,255,0.6);
    clear: both;
  }
  .sidr ul {
    padding: 0;
    border-top: 1px solid #1a1a1a;
    border-bottom: 1px solid #4d4d4d;
    top: 100%;
    float: left;
    min-width: 160px;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,0.15);
    border-radius: 4px;
  }
  .sidr ul li {
    margin: 0;
    line-height: 48px;
    border-top: 1px solid #4d4d4d;
    border-bottom: 1px solid #1a1a1a;
  }

  @media (max-width: 767px) {
    .sidr {
      top: 55px;
    }
  }
</style>
